import api from '../api/axios'

const mapasService = {
  async getConfig(organizadorId) {
    const res = await api.get(`/organizadores/${organizadorId}/mapas/config`)
    return res.data
  },

  async updateConfig(organizadorId, config) {
    const res = await api.put(`/organizadores/${organizadorId}/mapas/config`, config)
    return res.data
  },

  async getCompradores(organizadorId, leilaoId, { tipo = 'compras' } = {}) {
    const qs = new URLSearchParams()
    qs.set('tipo', tipo)
    const res = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/compradores?${qs}`
    )
    return res.data
  },

  async getMapaCompradorDados(organizadorId, leilaoId, { compradorId, tipo = 'padrao', ordenacao = 'numero_lote' } = {}) {
    const qs = new URLSearchParams()
    if (compradorId) qs.set('comprador_id', compradorId)
    qs.set('tipo', tipo)
    qs.set('ordenacao', ordenacao)
    const res = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/mapa-comprador-dados?${qs}`
    )
    return res.data
  },

  async getFaturaCompradorDados(organizadorId, leilaoId, { compradorId, tipo = 'padrao', separacao } = {}) {
    const qs = new URLSearchParams()
    if (compradorId) qs.set('comprador_id', compradorId)
    qs.set('tipo', tipo)
    if (compradorId && separacao) qs.set('separacao', JSON.stringify(separacao))
    const res = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/fatura-comprador-dados?${qs}`
    )
    return res.data
  },

  async getVendedores(organizadorId, leilaoId) {
    const res = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/vendedores`
    )
    return res.data
  },

  async getFaturaVendedorDados(organizadorId, leilaoId, { vendedorId, separacao } = {}) {
    const qs = new URLSearchParams()
    if (vendedorId) qs.set('vendedor_id', vendedorId)
    if (vendedorId && separacao) qs.set('separacao', JSON.stringify(separacao))
    const res = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/fatura-vendedor-dados?${qs}`
    )
    return res.data
  },

  async getClientesAcerto(organizadorId, leilaoId) {
    const res = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/clientes-acerto`
    )
    return res.data
  },

  async getFaturaAcertoDados(organizadorId, leilaoId, clienteId) {
    const qs = new URLSearchParams()
    if (clienteId) qs.set('cliente_id', clienteId)
    const res = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/fatura-acerto-dados?${qs}`
    )
    return res.data
  },

  async getFaturaAcertoPdf(organizadorId, leilaoId, clienteId) {
    const qs = new URLSearchParams()
    if (clienteId) qs.set('cliente_id', clienteId)
    const resp = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/fatura-acerto?${qs}`,
      { responseType: 'blob', timeout: 60000 }
    )
    return resp.data
  },

  async getMapaVendedorDados(organizadorId, leilaoId, { vendedorId } = {}) {
    const qs = new URLSearchParams()
    if (vendedorId) qs.set('vendedor_id', vendedorId)
    const res = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/mapa-vendedor-dados?${qs}`
    )
    return res.data
  },

  /**
   * Retorna a URL para download do PDF do Mapa do Comprador.
   * Abre em nova aba.
   */
  downloadMapaComprador(organizadorId, leilaoId, params = {}) {
    const {
      compradorId,
      tipo = 'padrao',
      dadosBancariosVendedor = false,
      ordenacao = 'numero_lote',
      dbBanco = '',
      dbAgencia = '',
      dbConta = '',
      dbPix = '',
    } = params

    const qs = new URLSearchParams()
    if (compradorId) qs.set('comprador_id', compradorId)
    qs.set('tipo', tipo)
    qs.set('dados_bancarios_vendedor', dadosBancariosVendedor)
    qs.set('ordenacao', ordenacao)
    if (dbBanco)   qs.set('db_banco',   dbBanco)
    if (dbAgencia) qs.set('db_agencia', dbAgencia)
    if (dbConta)   qs.set('db_conta',   dbConta)
    if (dbPix)     qs.set('db_pix',     dbPix)

    const baseUrl = api.defaults.baseURL || ''
    const url = `${baseUrl}/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/mapa-comprador?${qs.toString()}`
    window.open(url, '_blank')
  },
  async getListaVendedoresPdf(organizadorId, leilaoId, { vendedorId, separacao } = {}) {
    const qs = new URLSearchParams()
    if (vendedorId) qs.set('vendedor_id', vendedorId)
    if (vendedorId && separacao) qs.set('separacao', JSON.stringify(separacao))
    const resp = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/lista-vendedores?${qs}`,
      { responseType: 'blob', timeout: 60000 }
    )
    return resp.data
  },

  async getBalancoVendasDados(organizadorId, leilaoId) {
    const res = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/balanco-vendas-dados`
    )
    return res.data
  },

  async getBalancoVendasPdf(organizadorId, leilaoId) {
    const resp = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/balanco-vendas`,
      { responseType: 'blob', timeout: 60000 }
    )
    return resp.data
  },

  async getComissoesClienteDados(organizadorId, leilaoId) {
    const res = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/comissoes-cliente-dados`
    )
    return res.data
  },

  async getComissoesClientePdf(organizadorId, leilaoId) {
    const resp = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/comissoes-cliente`,
      { responseType: 'blob', timeout: 60000 }
    )
    return resp.data
  },

  // Comissões por Cliente por período + Excel (somente admin/financeiro — o backend também bloqueia)
  async getComissoesClientePeriodoDados(organizadorId, { dataInicio, dataFim }) {
    const qs = new URLSearchParams({ data_inicio: dataInicio, data_fim: dataFim })
    const res = await api.get(`/organizadores/${organizadorId}/mapas/comissoes-cliente-periodo-dados?${qs}`)
    return res.data
  },

  async getComissoesClientePeriodoPdf(organizadorId, { dataInicio, dataFim }) {
    const qs = new URLSearchParams({ data_inicio: dataInicio, data_fim: dataFim })
    const resp = await api.get(
      `/organizadores/${organizadorId}/mapas/comissoes-cliente-periodo?${qs}`,
      { responseType: 'blob', timeout: 60000 }
    )
    return resp.data
  },

  async getComissoesClienteXlsx(organizadorId, { leilaoId, dataInicio, dataFim } = {}) {
    const qs = new URLSearchParams()
    if (leilaoId) qs.set('leilao_id', leilaoId)
    else { qs.set('data_inicio', dataInicio); qs.set('data_fim', dataFim) }
    const resp = await api.get(
      `/organizadores/${organizadorId}/mapas/comissoes-cliente/exportar?${qs}`,
      { responseType: 'blob', timeout: 60000 }
    )
    return resp.data
  },

  async getComissaoLeiloeiroDados(organizadorId, { leilaoId, dataInicio, dataFim } = {}, versao = 'basico') {
    const qs = new URLSearchParams()
    if (leilaoId) qs.set('leilao_id', leilaoId)
    else { qs.set('data_inicio', dataInicio); qs.set('data_fim', dataFim) }
    qs.set('versao', versao)
    const res = await api.get(
      `/organizadores/${organizadorId}/mapas/comissao-leiloeiro-dados?${qs}`
    )
    return res.data
  },

  async getComissaoLeiloeiroPdf(organizadorId, { leilaoId, dataInicio, dataFim } = {}, versao = 'basico', leiloeiroId = null) {
    const qs = new URLSearchParams()
    if (leilaoId) qs.set('leilao_id', leilaoId)
    else { qs.set('data_inicio', dataInicio); qs.set('data_fim', dataFim) }
    qs.set('versao', versao)
    if (leiloeiroId) qs.set('leiloeiro_id', leiloeiroId)
    const resp = await api.get(
      `/organizadores/${organizadorId}/mapas/comissao-leiloeiro?${qs}`,
      { responseType: 'blob', timeout: 60000 }
    )
    return resp.data
  },

  async getComissaoLeiloeiroXlsx(organizadorId, { leilaoId, dataInicio, dataFim } = {}, versao = 'basico', leiloeiroId = null) {
    const qs = new URLSearchParams()
    if (leilaoId) qs.set('leilao_id', leilaoId)
    else { qs.set('data_inicio', dataInicio); qs.set('data_fim', dataFim) }
    qs.set('versao', versao)
    if (leiloeiroId) qs.set('leiloeiro_id', leiloeiroId)
    const resp = await api.get(
      `/organizadores/${organizadorId}/mapas/comissao-leiloeiro/exportar?${qs}`,
      { responseType: 'blob', timeout: 60000 }
    )
    return resp.data
  },

  async getMapaVendedorDefesaDados(organizadorId, leilaoId, { vendedorId, incluirNaoMov } = {}) {
    const qs = new URLSearchParams()
    if (vendedorId) qs.set('vendedor_id', vendedorId)
    if (incluirNaoMov) qs.set('incluir_nao_mov', 'true')
    const res = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/mapa-vendedor-defesa-dados?${qs}`
    )
    return res.data
  },

  async getVendedoresDefesa(organizadorId, leilaoId, { incluirNaoMov } = {}) {
    const qs = new URLSearchParams()
    if (incluirNaoMov) qs.set('incluir_nao_mov', 'true')
    const res = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/vendedores-defesa?${qs}`
    )
    return res.data
  },

  async getMapaVendedorDefesaPdf(organizadorId, leilaoId, { vendedorId, incluirNaoMov } = {}) {
    const qs = new URLSearchParams()
    if (vendedorId) qs.set('vendedor_id', vendedorId)
    if (incluirNaoMov) qs.set('incluir_nao_mov', 'true')
    const resp = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/mapa-vendedor-defesa?${qs}`,
      { responseType: 'blob', timeout: 60000 }
    )
    return resp.data
  },

  async getMapaGeralDados(organizadorId, leilaoId, tipo = 'liquido') {
    const qs = new URLSearchParams()
    qs.set('tipo', tipo)
    const res = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/mapa-geral-dados?${qs}`
    )
    return res.data
  },

  async getMapaGeralPdf(organizadorId, leilaoId, tipo = 'liquido', modo = 'completo') {
    const qs = new URLSearchParams()
    qs.set('tipo', tipo)
    qs.set('modo', modo)
    const resp = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/mapa-geral?${qs}`,
      { responseType: 'blob', timeout: 60000 }
    )
    return resp.data
  },

  async getMapaGeralNaoMovPdf(organizadorId, leilaoId) {
    const resp = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/mapa-geral-naomov`,
      { responseType: 'blob', timeout: 60000 }
    )
    return resp.data
  },

  async getMapaGeralDefesasPdf(organizadorId, leilaoId) {
    const resp = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/mapa-geral-defesas`,
      { responseType: 'blob', timeout: 60000 }
    )
    return resp.data
  },

  async getRankingClientes(organizadorId, tipo, dataInicio, dataFim) {
    const qs = new URLSearchParams()
    qs.set('tipo', tipo)
    qs.set('data_inicio', dataInicio)
    qs.set('data_fim', dataFim)
    const res = await api.get(`/organizadores/${organizadorId}/mapas/ranking-clientes?${qs}`)
    return res.data
  },

  async getRankingClientesPdf(organizadorId, tipo, dataInicio, dataFim) {
    const qs = new URLSearchParams()
    qs.set('tipo', tipo)
    qs.set('data_inicio', dataInicio)
    qs.set('data_fim', dataFim)
    const resp = await api.get(
      `/organizadores/${organizadorId}/mapas/ranking-clientes-pdf?${qs}`,
      { responseType: 'blob', timeout: 60000 }
    )
    return resp.data
  },

  async getRelacaoClientes(organizadorId, leilaoId, tipo, { ordenacao = 'valor', mostrarSexo = false, mostrarQtdLotes = false, ocultarValorLiquido = false, ocultarValorBruto = false, mostrarPctComissao = false } = {}) {
    const qs = new URLSearchParams()
    qs.set('tipo', tipo)
    qs.set('ordenacao', ordenacao)
    qs.set('mostrar_sexo', String(mostrarSexo))
    qs.set('mostrar_qtd_lotes', String(mostrarQtdLotes))
    qs.set('ocultar_valor_liquido', String(ocultarValorLiquido))
    qs.set('ocultar_valor_bruto', String(ocultarValorBruto))
    qs.set('mostrar_pct_comissao', String(mostrarPctComissao))
    const res = await api.get(`/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/relacao-clientes?${qs}`)
    return res.data
  },

  async getRelacaoClientesPdf(organizadorId, leilaoId, tipo, { ordenacao = 'valor', mostrarSexo = false, orientacao = 'portrait', mostrarQtdLotes = false, ocultarValorLiquido = false, ocultarValorBruto = false, mostrarPctComissao = false } = {}) {
    const qs = new URLSearchParams()
    qs.set('tipo', tipo)
    qs.set('ordenacao', ordenacao)
    qs.set('mostrar_sexo', String(mostrarSexo))
    qs.set('orientacao', orientacao)
    qs.set('mostrar_qtd_lotes', String(mostrarQtdLotes))
    qs.set('ocultar_valor_liquido', String(ocultarValorLiquido))
    qs.set('ocultar_valor_bruto', String(ocultarValorBruto))
    qs.set('mostrar_pct_comissao', String(mostrarPctComissao))
    const resp = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/relacao-clientes-pdf?${qs}`,
      { responseType: 'blob', timeout: 60000 }
    )
    return resp.data
  },

  async getRelacaoVendedoresNominal(organizadorId, leilaoId, ordenar = 'nome') {
    const res = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/relacao-vendedores-nominal`,
      { params: { ordenar } }
    )
    return res.data
  },

  async saveRelacaoVendedoresNominal(organizadorId, leilaoId, vendedores) {
    const res = await api.put(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/relacao-vendedores-nominal`,
      { vendedores }
    )
    return res.data
  },

  async getRelacaoVendedoresNominalPdf(organizadorId, leilaoId, ordenar = 'nome') {
    const resp = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/relacao-vendedores-nominal-pdf`,
      { params: { ordenar }, responseType: 'blob', timeout: 60000 }
    )
    return resp.data
  },

  async getRelacaoVendedoresDetalhada(organizadorId, leilaoId) {
    const res = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/relacao-vendedores-lotes`
    )
    return res.data
  },

  async getRelacaoVendedoresDetPdf(organizadorId, leilaoId) {
    const resp = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/relacao-vendedores-lotes-pdf`,
      { responseType: 'blob', timeout: 60000 }
    )
    return resp.data
  },

  async getLiberacaoCurralDados(organizadorId, leilaoId, compradorId, tipo = 'compras_defesas') {
    const qs = new URLSearchParams()
    qs.set('comprador_id', compradorId)
    qs.set('tipo', tipo)
    const res = await api.get(`/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/liberacao-curral-dados?${qs}`)
    return res.data
  },

  async getLiberacaoInfo(organizadorId, leilaoId, compradorId) {
    const qs = new URLSearchParams({ comprador_id: compradorId })
    const res = await api.get(`/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/liberacao-info?${qs}`)
    return res.data
  },

  async salvarLiberacaoInfo(organizadorId, leilaoId, { compradorId, motoristaId, motoristaNome, placa, valorFrete, ordemEmbarque }) {
    const qs = new URLSearchParams({ comprador_id: compradorId })
    if (motoristaId) qs.set('motorista_id', motoristaId)
    if (motoristaNome) qs.set('motorista_nome', motoristaNome)
    if (placa) qs.set('placa', placa)
    if (valorFrete) qs.set('valor_frete', valorFrete)
    if (ordemEmbarque != null && ordemEmbarque !== '') qs.set('ordem_embarque', ordemEmbarque)
    await api.post(`/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/liberacao-info?${qs}`)
  },

  async getLiberacaoCurralPdf(organizadorId, leilaoId, compradorId, placa = '', motorista = '', valorFrete = 0, versao = '1', tipo = 'compras_defesas') {
    const qs = new URLSearchParams()
    qs.set('comprador_id', compradorId)
    if (placa) qs.set('placa', placa)
    if (motorista) qs.set('motorista', motorista)
    if (valorFrete > 0) qs.set('valor_frete', valorFrete)
    if (versao && versao !== '1') qs.set('versao', versao)
    qs.set('tipo', tipo)
    const resp = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/liberacao-curral?${qs}`,
      { responseType: 'blob', timeout: 60000 }
    )
    return resp.data
  },

  async getLiberacaoCurralGeralPdf(organizadorId, leilaoId, tipo = 'compras') {
    const resp = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/liberacao-curral-geral?tipo=${tipo}`,
      { responseType: 'blob', timeout: 120000 }
    )
    return resp.data
  },

  async getOrdemEmbarquePdf(organizadorId, leilaoId) {
    const resp = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/ordem-embarque`,
      { responseType: 'blob', timeout: 60000 }
    )
    return resp.data
  },

  async getOrdemEmbarqueDados(organizadorId, leilaoId) {
    const resp = await api.get(`/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/ordem-embarque-dados`)
    return resp.data
  },

  async getAutorizacaoGTADados(organizadorId, leilaoId, compradorId, tipo = 'compras_defesas') {
    const qs = new URLSearchParams()
    if (compradorId && compradorId !== 'todos') qs.set('comprador_id', compradorId)
    qs.set('tipo', tipo)
    const res = await api.get(`/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/autorizacao-gta-dados?${qs}`)
    return res.data
  },

  async getAutorizacaoGTAPdf(organizadorId, leilaoId, compradorId, tipo = 'compras_defesas') {
    const qs = new URLSearchParams()
    if (compradorId && compradorId !== 'todos') qs.set('comprador_id', compradorId)
    qs.set('tipo', tipo)
    const resp = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/autorizacao-gta?${qs}`,
      { responseType: 'blob', timeout: 60000 }
    )
    return resp.data
  },

  async getContratoUnificadoPdf(organizadorId, leilaoId, compradorId, modalidade = null, incluirDefesa = false) {
    const qs = new URLSearchParams()
    qs.set('comprador_id', compradorId)
    if (modalidade) qs.set('modalidade', modalidade)
    if (incluirDefesa) qs.set('incluir_defesa', 'true')
    const resp = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/contrato-unificado?${qs}`,
      { responseType: 'blob', timeout: 60000 }
    )
    return resp.data
  },

  async getContrato3ViasPdf(organizadorId, leilaoId, compradorId) {
    const qs = new URLSearchParams()
    qs.set('comprador_id', compradorId)
    const resp = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/contrato-3-vias?${qs}`,
      { responseType: 'blob', timeout: 120000 }
    )
    return resp.data
  },

  async getContratoUnificadoResumo(organizadorId, leilaoId, compradorId, modalidade = null) {
    const qs = new URLSearchParams()
    qs.set('comprador_id', compradorId)
    if (modalidade) qs.set('modalidade', modalidade)
    const res = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/contrato-unificado-resumo?${qs}`
    )
    return res.data
  },

  async getNegociacao(organizadorId, leilaoId, compradorId, modalidade = '') {
    const qs = new URLSearchParams({ leilao_id: leilaoId, comprador_id: compradorId, modalidade })
    const res = await api.get(`/organizadores/${organizadorId}/contratos/negociacao?${qs}`)
    return res.data
  },

  async saveNegociacao(organizadorId, payload) {
    const res = await api.put(`/organizadores/${organizadorId}/contratos/negociacao`, payload)
    return res.data
  },

  async deleteNegociacao(organizadorId, leilaoId, compradorId, modalidade = '') {
    const qs = new URLSearchParams({ leilao_id: leilaoId, comprador_id: compradorId, modalidade })
    await api.delete(`/organizadores/${organizadorId}/contratos/negociacao?${qs}`)
  },

  async getListagemCompradoresDados(organizadorId, leilaoId, vendedorPor = 'fazenda', extra = {}) {
    const res = await api.get(`/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/listagem-compradores-dados`, { params: { vendedor_por: vendedorPor, ...extra } })
    return res.data
  },

  async getListagemCompradoresPdf(organizadorId, leilaoId, vendedorPor = 'fazenda', extra = {}) {
    const resp = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/listagem-compradores`,
      { responseType: 'blob', timeout: 60000, params: { vendedor_por: vendedorPor, ...extra } }
    )
    return resp.data
  },

  async getMapaGeralVendedoresDados(organizadorId, leilaoId) {
    const res = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/mapa-geral-vendedores-dados`
    )
    return res.data
  },

  async getMapaGeralVendedoresPdf(organizadorId, leilaoId) {
    const resp = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/mapa-geral-vendedores`,
      { responseType: 'blob', timeout: 60000 }
    )
    return resp.data
  },

  async getMapaGeralCompradoresDados(organizadorId, leilaoId) {
    const res = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/mapa-geral-compradores-dados`
    )
    return res.data
  },

  async getMapaGeralCompradoresPdf(organizadorId, leilaoId) {
    const resp = await api.get(
      `/organizadores/${organizadorId}/mapas/leilao/${leilaoId}/mapa-geral-compradores`,
      { responseType: 'blob', timeout: 60000 }
    )
    return resp.data
  },

  // alvo: 'ambos' | 'gta' | 'nota'
  async isentarGTA(organizadorId, compradorId, leilaoId, alvo = 'ambos') {
    const res = await api.post(
      `/organizadores/${organizadorId}/lotes/isentar-gta`,
      { comprador_id: compradorId, leilao_id: leilaoId, alvo }
    )
    return res.data
  },

  async desfazerIsencaoGTA(organizadorId, compradorId, leilaoId, alvo = 'ambos') {
    const res = await api.post(
      `/organizadores/${organizadorId}/lotes/desfazer-isencao-gta`,
      { comprador_id: compradorId, leilao_id: leilaoId, alvo }
    )
    return res.data
  },

  async isentarGTALote(organizadorId, loteId, alvo = 'ambos') {
    const res = await api.post(
      `/organizadores/${organizadorId}/lotes/${loteId}/isentar-gta`,
      { alvo }
    )
    return res.data
  },

  async desfazerIsencaoGTALote(organizadorId, loteId, alvo = 'ambos') {
    const res = await api.post(
      `/organizadores/${organizadorId}/lotes/${loteId}/desfazer-isencao-gta`,
      { alvo }
    )
    return res.data
  },
}

export default mapasService
